import GenericCard from '../../../../components/GenericCards';
import { Col, Row } from 'react-bootstrap';
import IconButton from '../../../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { convertToUnits, formatPrice } from '../../../../utils/utils';
import Button from '../../../../components/Button';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateChartOptions = () => {
  return {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    legend: {
      show: false,
    },
    toolbar: false,
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ['1', '2', '3', '4'],
      show: false,
      labels: {
        formatter: function (value: any) {
          return value !== 0 ? convertToUnits(value) : 0;
        },
      },
    },
    yaxis: {
      show: false,
      lines: {
        show: true,
      },
    },
  };
};

const generateChartSeries = (data: any[]) => {
  return [
    ...data.map((d) => {
      return {
        name: d.contribution,
        color: d.color,
        data: [d.contributionAmount],
      };
    }),
  ];
};

export const ContributionsAndLimits = () => {
  const [showContributionsChart, setShowContributionsChart] =
    useState<boolean>(false);

  const contributions = [
    {
      color: '#074CBC',
      contribution: 'YTD Contributions',
      contributionAmount: 2212.27,
    },
    {
      color: '#F48462',
      contribution: 'YTD Catch-Up Contribution',
      contributionAmount: 2000.0,
    },
    {
      color: '#07B4A0',
      contribution: 'YTD Total',
      contributionAmount: 4212.27,
    },
  ];

  const irsLimits = [
    {
      title: 'IRS Limit',
      amount: 20500,
    },
    {
      title: 'Catch-Up Contribution',
      amount: 6500,
    },
  ];
  return (
    <GenericCard variant={'white'}>
      <Row className="align-items-center">
        <Col className={'col-10'}>
          <h5>Contributions & Limits</h5>
        </Col>
        <Col className={'col-2'}>
          <IconButton
            variant="icon-emphasized"
            icon={
              !showContributionsChart
                ? light('pie-chart')
                : light('circle-minus')
            }
            onClick={() => setShowContributionsChart((prevState) => !prevState)}
          />
        </Col>
      </Row>
      <Row className="mt-10">
        <Col className={'col-12'}>
          <Row>
            <Col
              className={`col-12 ${
                !showContributionsChart ? 'd-none' : 'd-block'
              }`}
            >
              <Chart
                options={generateChartOptions() as ApexOptions}
                series={generateChartSeries(contributions)}
                type={'bar'}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Row className="text-fs-6 fw-light pt-3 lh-xs border-bottom">
                <Col className="text-start fw-normal p-0 col-12 pb-3">
                  Contributions{' '}
                  <FontAwesomeIcon
                    icon={light('question-circle')}
                    className={'ms-2'}
                  />
                </Col>
              </Row>
              {contributions.map((contributionPoint, index) => {
                return (
                  <Row
                    className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom "
                    key={index}
                  >
                    <Col className="pt-1 ps-0 col-1 pe-0">
                      <div
                        className="custom-legend-marker"
                        style={{
                          backgroundColor: `${contributionPoint.color}`,
                        }}
                      ></div>
                    </Col>
                    <Col className="col-6 ps-0 ">
                      {contributionPoint.contribution}
                    </Col>

                    <Col className="col-5 text-end pe-0">
                      {formatPrice(
                        Number(contributionPoint.contributionAmount),
                        'en-US',
                        {
                          currency: 'USD',
                          style: 'currency',
                          minimumFractionDigits: 2,
                        }
                      )}
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
          <Row
            className={
              'text-fs-6 fw-normal lh-xs pt-3 pb-3 px-3 gray-nested-background align-items-center'
            }
          >
            <Col className="pt-1 ps-0 col-1 pe-0">
              <div
                className="custom-legend-marker"
                style={{
                  backgroundColor: `#EEA968`,
                }}
              ></div>
            </Col>
            <Col className="col-7 ps-0">Estimated Year End Total</Col>
            <Col className="col-4 text-end pe-0">
              {formatPrice(Number(6318.0), 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 2,
              })}
            </Col>
          </Row>
        </Col>

        <Col className={'col-12 mt-5'}>
          <Row>
            <Col>
              <Row className="text-fs-6 fw-light pt-3 lh-xs border-bottom">
                <Col className="text-start fw-normal p-0 col-12 pb-3">
                  IRS Limit
                  <FontAwesomeIcon
                    icon={light('question-circle')}
                    className={'ms-2'}
                  />
                </Col>
              </Row>
              {irsLimits.map((irsLimit, index) => {
                return (
                  <Row
                    className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom "
                    key={index}
                  >
                    <Col className="col-8 ps-0 ">{irsLimit.title}</Col>

                    <Col className="col-4 text-end pe-0">
                      {formatPrice(Number(irsLimit.amount), 'en-US', {
                        currency: 'USD',
                        style: 'currency',
                        minimumFractionDigits: 2,
                      })}
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
          <Row
            className={
              'text-fs-6 fw-light lh-xs pt-3 pb-3 px-3  gray-nested-background fw-bold '
            }
          >
            <Col className="col-8 ps-0">Total</Col>
            <Col className="col-4 text-end pe-0">$27,000.00</Col>
          </Row>
        </Col>

        <Col className={'col-12 mt-5 text-end d-none d-lg-block'}>
          <Button color={'blue'}>Change Contributions</Button>
        </Col>
        <Col className={'col-12 mt-5 text-end d-lg-none'}>
          <Button color={'blue'} variant={'primary-outline'}>
            More Details
          </Button>
        </Col>
      </Row>
    </GenericCard>
  );
};
